<template>
  <v-container>
    <v-layout class="justify-center">
      <h2 class="font-weight-light display-1 ma-3">
        Create a <span class="yellow--text text--darken-2">Pick'em</span> Instaplay
      </h2>
    </v-layout>
    <instaplay-form></instaplay-form>
  </v-container>
</template>


<script>
    import InstaplayForm from "@/components/InstaplayForm";

    export default {
        name: "Create",
        components: {InstaplayForm},
    }
</script>

<style scoped>

</style>
